import i18next from 'i18next';
import React from 'react';
import theme from '@theme';

import { Dropdown } from '@commons/utils/styledLibraryComponents';
import InputContentModal from '@commons/Modals/InputContentModal';
import Text, { ENUM_COLORS, ENUM_FONTS } from '@commons/Text';

import {
  Container,
  DropdownContainer,
  DropdownsContainer,
  InputContainer,
  InputsContainer,
  LinkedStoreIcon,
  LinkedStoreIconContainer,
  StoreDropdownItem,
  StoreName,
} from './styledComponents';
import { VARIANT_MODAL_DROPDOWN_LIST_MAX_HEIGHT, VARIANT_MODAL_DROPDOWN_WIDTH } from './constants';

const renderStoreDropdownItem = (store) => (
  <StoreDropdownItem>
    <StoreName isDisabled={store.isDisabled}>{store.name}</StoreName>
    {store.showLinkIcon && (
      <LinkedStoreIconContainer>
        <LinkedStoreIcon src="/images/inpulse/link-black-small.svg" />
      </LinkedStoreIconContainer>
    )}
  </StoreDropdownItem>
);

const RecipeVariantModal = ({
  introTranslationKey,
  hideVariantNameInput,
  variantName,
  setVariantName,
  isVariantNameLocked,
  nameErrorMessage,
  groups,
  selectedGroups,
  setSelectedGroups,
  stores,
  selectedStores,
  setSelectedStores,
}) => {
  const dropdownListStyle = {
    maxHeight: VARIANT_MODAL_DROPDOWN_LIST_MAX_HEIGHT,
  };

  const storesWithCustomRender = stores.map((store) => ({
    ...store,
    renderValue: () => renderStoreDropdownItem(store),
  }));

  return (
    <Container>
      <Text color={ENUM_COLORS.DARKER} font={ENUM_FONTS.TEXT_SMALL}>
        {i18next.t(introTranslationKey)}
      </Text>
      <InputsContainer>
        {!hideVariantNameInput && (
          <InputContainer>
            <InputContentModal
              autoFocus={!isVariantNameLocked}
              errorMessage={nameErrorMessage}
              label={`* ${i18next.t('ADMIN.RECIPES.VARIANT_MODAL.NAME_LABEL')}`}
              readOnly={isVariantNameLocked}
              value={variantName}
              onChange={setVariantName}
            />
          </InputContainer>
        )}
        <DropdownsContainer>
          {!!groups.length && (
            <DropdownContainer>
              <Dropdown
                customDropdownListStyle={dropdownListStyle}
                customStyle={{ position: 'inherit', width: VARIANT_MODAL_DROPDOWN_WIDTH }}
                height={'68px'}
                iconSrc={'/images/inpulse/group-black-small.svg'}
                isUniqueSelection={false}
                items={groups}
                label={i18next.t('ADMIN.RECIPES.VARIANT_MODAL.GROUPS_LABEL')}
                labelStyle={{ font: theme.fonts.textSmall }}
                selectedItems={selectedGroups}
                onSelectionChange={setSelectedGroups}
              />
            </DropdownContainer>
          )}
          <DropdownContainer>
            <Dropdown
              customDropdownListStyle={dropdownListStyle}
              customStyle={{ position: 'inherit', width: VARIANT_MODAL_DROPDOWN_WIDTH }}
              height={'68px'}
              iconSrc={'/images/inpulse/store-black-small.svg'}
              isUniqueSelection={false}
              items={storesWithCustomRender}
              label={i18next.t('ADMIN.RECIPES.VARIANT_MODAL.STORES_LABEL')}
              labelStyle={{ font: theme.fonts.textSmall }}
              selectedItems={selectedStores}
              onSelectionChange={setSelectedStores}
            />
          </DropdownContainer>
        </DropdownsContainer>
      </InputsContainer>
    </Container>
  );
};

export default RecipeVariantModal;
